import React, { ChangeEvent, KeyboardEvent, useId, useState } from "react";
import { ValueSetGet } from "../../../Editor/shapes/shapeHelper/getSetProperties";

interface NumberInputProp extends ValueSetGet<number> {
  propertyDisplayName: string;
}

const NumberInput = ({
  setValue,
  currentValue,
  propertyDisplayName,
}: NumberInputProp) => {
  const inputID = useId();
  const [inputValue, setInputValue] = useState<number>(currentValue)

  const changeHandle = (e: ChangeEvent<HTMLInputElement>) => {
    const number = parseFloat(e.target.value) || 0;
    setInputValue(number);
  }

  const keydownHandle = (e: KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation();
    if (e.key === "Enter") {
      insertValue();
    }
  }

  const insertValue = () => {
    setValue(inputValue);
  }

  return (
    <>
      <label htmlFor={inputID} className="element__part__name">
        {propertyDisplayName}
      </label>
      <input
        id={inputID}
        type="number"
        value={inputValue.toString()}
        onChange={changeHandle}
        onKeyDown={keydownHandle}
        onBlur={insertValue}
      />
    </>
  );
};

export default NumberInput;
